export default class technicalFormat {
	constructor(){
		this.info = null;
	}
	getInfoTechnical(){
		return this.info;
	}
	setInfo(deviceID, item){ //  for mapview
		if (item) {
			// console.log("ITEM technicalFormat ", deviceID, item )
			let setOption = null;
			
			// Verificar si existe rtsp
			if (item.rtsp) {
				setOption = "rtsp";
			}
			// Si no hay rtsp pero hay retransmission_local, usar ese
			else if (item.retransmission_local) {
				setOption = "retransmission_local";
			}
			
			// Solo crear info si tenemos una opción válida
			if (setOption && item[setOption]) {
				this.info = {
					deviceId 	: deviceID,
					code 		: item[setOption].code ? item[setOption].code : null,
					state 		: item[setOption].state,
					icon_code   : item[setOption].icon,  
					manager_id  : item.manager_id, 
				}
			} else {
				// Si no hay opción válida, crear info con valores por defecto
				this.info = {
					deviceId 	: deviceID,
					code 		: null,
					state 		: null,
					icon_code   : null,  
					manager_id  : item.manager_id || null, 
				}
			}
		}
	}
}